import { render, staticRenderFns } from "./ListOcorrencias.vue?vue&type=template&id=241ab3af&"
import script from "./ListOcorrencias.vue?vue&type=script&lang=js&"
export * from "./ListOcorrencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports